import { render, staticRenderFns } from "./PreviewPassageAndBundleQuestion.vue?vue&type=template&id=4f1bb604&scoped=true"
import script from "./PreviewPassageAndBundleQuestion.vue?vue&type=script&lang=js"
export * from "./PreviewPassageAndBundleQuestion.vue?vue&type=script&lang=js"
import style0 from "./PreviewPassageAndBundleQuestion.vue?vue&type=style&index=0&id=4f1bb604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1bb604",
  null
  
)

export default component.exports